export default __webpack_public_path__ + "static/media/diagram_free.9da1895a.svg";